import BasePage from  './basePage';
import VideoPlayer from "promokit-videoplayer";

export default class Episode1 extends BasePage{
  constructor(info){
    super(info);

    this.showMotion;

    this._motionSet();

    this.player = new VideoPlayer({
      el: "#episode1_bg",
      url: "https://vod.plaync.com/lineage/episode1/episode1_bg.mp4",
      loop: true,
      autoplay: true
    });
  }
  _motionSet(){
    this.showMotion = new TimelineMax({paused: true, onComplete: this._showCompleteContent, onCompleteParams: [this]});
    this.showMotion
      .fromTo(this.ele.querySelector('.txt-1'), 1, {autoAlpha:0}, {autoAlpha:1, ease: Quart.easeOut}, '+=1')
      .fromTo(this.ele.querySelector('.txt-2'), 1, {autoAlpha:0, y:30}, {autoAlpha:1, y:0, ease: Quart.easeOut}, '-=0.5')
      .staggerFromTo(this.ele.querySelectorAll('.st0'), 0.5, {drawSVG:0}, {drawSVG:"102%"}, '0.05', '-=0.5')
      .fromTo(this.ele.querySelector('.txt-4'), 1.2, {autoAlpha:0}, {autoAlpha:1, ease: Quart.easeIn}, '-=1')
      .fromTo(this.ele.querySelector('.txt-4>span'), 1, {autoAlpha:1}, {autoAlpha:0, ease: Quart.easeOut}, '-=0')
      .fromTo(this.ele.querySelector('.util'), 0.5, {autoAlpha:0, y:50}, {autoAlpha:1, y:0, ease: Quart.easeOut}, '-=2.5')
      .fromTo(this.ele.querySelector('.icon-scroll'), 0.5, {autoAlpha:0, y:50}, {autoAlpha:1, y:0, ease: Quart.easeOut}, '-=2.3')
      .fromTo(this.ele.querySelector('.episode-btn'), 1, {autoAlpha:0, y:30}, {autoAlpha:1, y:0, ease: Quart.easeOut}, '-=2')
      .fromTo(this.ele.querySelector('.episode-btn span'), 0.7, {autoAlpha:0}, {autoAlpha:1, ease: Quart.easeOut}, '-=2')
      .to(this.ele.querySelector('.episode-btn span'), 1, {autoAlpha:0}, '-=1.5')

   /* this.player.on("canplay", ()=>{
      this.player.stop();
    })*/
    //this.player.stop();
  };
  show(size, dx){
    super.show(size, dx)
    this.showMotion.seek(0)
    this.showMotion.play();
    this.player.play();
  }
  hide(size, dx, moveSec){
    super.hide(size, dx, moveSec)
    this.showMotion.pause();
    this.player.stop();

  }
  _showCompleteContent(){

  }


}



// WEBPACK FOOTER //
// ./src/js/page/episode1.js